/* global FB ui */
import addClickTrackingHandler from './utils/addClickTrackingHandler';
import debounce from './utils/debounce';
import events from './utils/events';
import facebookSignIn from './utils/facebook/facebookSignIn';
import framePage from './utils/framePage';
import redirectIfNotInFrame from './utils/redirectIfNotInFrame';
import sendMessageToParent from './utils/sendMessageToParent';
import submitForm from './index/submitForm';

($ => {
	$(() => {
		redirectIfNotInFrame();
		addClickTrackingHandler();
		sendMessageToParent(events.SIGNIN_START);
		let height = $('body').height();
		sendMessageToParent('FRAME_RESIZE', { height });
		const sendHeightToParent = debounce(() => {
			const newHeight = $('body').height();
			if (newHeight !== height) {
				height = newHeight;
				sendMessageToParent('FRAME_RESIZE', { height });
			}
		}, 20);

		framePage.$fbSignInBtn = $('#fbSignInBtn');
		framePage.$password = $('#password');
		framePage.$signInBtn = $('#signInBtn');
		framePage.$title = $('#title');
		framePage.$username = $('#username');

		$.ajaxSetup({ cache: true });

		$.getScript('//connect.facebook.net/en_US/sdk.js', () => {
			const fbInitOptions = {
				appId: framePage.$fbSignInBtn.data('fbAppId'),
				cookie: true, // enable cookies to allow the server to access the session
				xfbml: true, // parse social plugins on this page
				version: framePage.$fbSignInBtn.data('fbGraphApiVersion')
			};
			FB.init(fbInitOptions);

			framePage.$fbSignInBtn.on('click', () => {
				framePage.$fbSignInBtn.addClass('loading');
				facebookSignIn(framePage.$fbSignInBtn.data('fbPermissions'));
			});
		});

		const $signInForm = document.getElementById('signInForm');

		const validator = ui.validator($signInForm, {
			allowMultipleSubmissions: true,
			fields: {
				password: {
					required: true,
					errorLocation: 'below',
					pattern: ({ value: sample, field: $field }) => {
						const errorLabel = document.querySelector(`label[for="${$field.name}"]`);
						if (sample.length === 0) {
							validator.updateValidationMessage($field.id, false, errorLabel.getAttribute('data-error-0'));
							return false;
						}
						if (sample.length < 5) {
							validator.updateValidationMessage($field.id, false, errorLabel.getAttribute('data-error-1'));
							return false;
						}
						return true;
					},
					when: 'submit'
				},
				username: {
					required: true,
					errorLocation: 'below',
					pattern: ({ value: sample, field: $field }) => {
						const errorLabel = document.querySelector(`label[for="${$field.name}"]`);
						if (sample.length === 0) {
							validator.updateValidationMessage($field.id, false, errorLabel.getAttribute('data-error-0'));
							return false;
						}
						if (sample.length < 4) {
							validator.updateValidationMessage($field.id, false, errorLabel.getAttribute('data-error-1'));
							return false;
						}
						if (
							!/^[a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÄËÏÖÜçÇßøØåÅæÆþÞðÐ\d\s'.,-@_+]{4,64}$/.test(sample)
						) {
							validator.updateValidationMessage($field.id, false, errorLabel.getAttribute('data-error-2'));
							return false;
						}
						return true;
					},
					when: 'submit'
				}
			},
			onSubmit: submitForm
		});

		$signInForm[0].removeAttribute('onsubmit');
		framePage.$username.focus();

		const heightObserver = new MutationObserver(sendHeightToParent);
		heightObserver.observe(document.body, { attributes: true, childList: true, subtree: true });

		window.addEventListener('resize', sendHeightToParent);

		const showPass = document.getElementById('showPasswordButton');
		const hidePass = document.getElementById('hidePasswordButton');
		const passField = document.getElementById('password');
		showPass.addEventListener('click', () => {
			showPass.classList.add('noDisplay');
			hidePass.classList.remove('noDisplay');
			passField.setAttribute('type', 'text');
			hidePass.focus();
		});
		hidePass.addEventListener('click', () => {
			hidePass.classList.add('noDisplay');
			showPass.classList.remove('noDisplay');
			passField.setAttribute('type', 'password');
			showPass.focus();
		});
	});
})(jQuery);
